import {
  DASHBOARD_ELEMENT_ALL,
  DASHBOARD_ELEMENT_GET,
  DASHBOARD_ELEMENT_DELETE,
  DASHBOARD_ELEMENT_PUT,
  DASHBOARD_ELEMENT_POST,
  DASHBOARD_ELEMENT_LOADING,
  DASHBOARD_ELEMENT_ERROR,
} from '../types';

import api from '../../../configs/api';
import graphqlClient from '../../../configs/graphqlClient';

export const dashboardElementCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: DASHBOARD_ELEMENT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/dashboard-element`,
      {
        ...payload,
      },
    );
    dispatch({ type: DASHBOARD_ELEMENT_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DASHBOARD_ELEMENT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const dashboardElementAll = ({
  name = '',
  size = 10,
  page = 1,
}) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/dashboard-element?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: DASHBOARD_ELEMENT_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: DASHBOARD_ELEMENT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const dashboardElementAllQuery = ({ query }) => async (dispatch) => {
  try {
    const queryResult = await graphqlClient.request(query);
    const data = queryResult?.findUnits;
    //  console.log('Query Data', queryResult);
    if (!data) {
      dispatch({ type: DASHBOARD_ELEMENT_ERROR });
    }

    dispatch({ type: DASHBOARD_ELEMENT_ALL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DASHBOARD_ELEMENT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const dashboardElementGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/dashboard-element/${id}`,
    );
    if (status === 200) {
      dispatch({ type: DASHBOARD_ELEMENT_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: DASHBOARD_ELEMENT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const dashboardElementStateSet = (data) => async (dispatch) => {
  dispatch({ type: DASHBOARD_ELEMENT_ALL, payload: data });
};

export const dashboardElementStateOneSet = (data) => async (dispatch) => {
  dispatch({ type: DASHBOARD_ELEMENT_GET, payload: data });
};

export const dashboardElementReset = () => async (dispatch) => {
  dispatch({ type: DASHBOARD_ELEMENT_LOADING });
};

export const dashboardElementError = () => async (dispatch) => {
  dispatch({ type: DASHBOARD_ELEMENT_ERROR });
};

export const dashboardElementPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: DASHBOARD_ELEMENT_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/dashboard-element/${id}`,
      payload,
    );
    dispatch({ type: DASHBOARD_ELEMENT_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DASHBOARD_ELEMENT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};
export const dashboardElementDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: DASHBOARD_ELEMENT_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/dashboard-element/${id}`,
    );
    dispatch({ type: DASHBOARD_ELEMENT_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DASHBOARD_ELEMENT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};
